
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';

function Security() {
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    // <div className="facility-container">
    //   <div className="facility-box">
    //     <h2 className="facility-title">SECURITY SYSTEM/ID CARDS</h2>
    //     <p className="facility-text">
    //         <div>Security The Academy has a well organized security system which has been set up in order to ensure the safety and welfare of the students. All parents and visitors are requested to honour the security rules and help us to maintain proper order and discipline. Collector cards are issued to parents and drivers/guardians. Insistence on showing the ID cards by our security staff may please be taken in the right spirit.</div>
    //     </p>
    //   </div>
    // </div>
    <Container className="my-5">
      <Row>
        <Col xs={6} md={5}>
          <div data-aos="flip-left" data-aos-duration="2500">
            <Image
              src="imagesspecialfacilities/Security.jpg"
              rounded
              style={{ width: '100%', objectFit: 'cover', marginTop: '20px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
            />
          </div>
        </Col>
        <Col xs={6} md={7}>
          <div className="facility-text">
            <h2 className="facility-title">SECURITY SYSTEM/ID CARDS</h2>
            <br />
            <p>
              The Academy has a well organized security system which has been set up in order to ensure the safety and welfare of the students. All parents and visitors are requested to honour the security rules and help us to maintain proper order and discipline. Collector cards are issued to parents and drivers/guardians. Insistence on showing the ID cards by our security staff may please be taken in the right spirit.            </p>
          </div>
        </Col>
      </Row>

    </Container>
  );
}

export default Security;